import { PageCESU } from "../../common/utils/menu/pagesEBU";
import HomePageEbu from "../homepageEbu";

export const PagesArchitectureMenuEbUnique = {
    [PageCESU.LOGIN]: {
        breadcrumbText: "Connexion",
        route: `${HomePageEbu.CESU}/login`,
        routeWithParamDesc: "/:contractId/login",
        routeWithParam: contractId => "/" + contractId + "/login",
    }
}
